import $ from 'jquery';

const defaults = {
  menuPods: '.menu-pods',
};

function MenuPods(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.init();
  this.ready();
}

MenuPods.prototype = {
  init() {
    const podsBlock = $(document).find(this.settings.menuPods);
    const $podsBlock = $(podsBlock);

    // cycle through the first level terms
    this.$element.find('li.depth-1.menuparent').each((i, item) => {
      const $item = $(item);
      const $list = $item.find('ul.depth-2');
      const navterm = $item.attr('class').match(/mt-(\w+)\s/);

      // wrap all the links in a separate container
      $list.children().wrapAll('<div class="term-links"></div>');

      if (navterm && $podsBlock.length) {
        // grab a qualifying node that is tagged to the current cycled term
        const $node = $podsBlock.find(`.node.wt${navterm[1]}`).eq(0);
        if ($node.length) {
          const $termHighlight = $('<div class="term-highlight"></div>');
          $termHighlight.append($node);
          $termHighlight.appendTo($list);

          // add a helper class to theme appropriately
          $list.addClass('has-highlight');
        }
      }
      $list.children().wrapAll('<div class="term-links-wrapper"></div>');
    });
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default MenuPods;
